export enum InjectionMoldingHardwareItemType {
    Resin = 'resin',
    Colorant = 'colorant',
    Hardware = 'hardware',
}
